import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
// import { getLoggedIn, getPending, AuthService, AuthState } from '.';
import { take, filter, switchMap, map } from 'rxjs/operators';
import { AuthState, getLoggedIn, getPending } from '../store';
import { AuthService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class Auth2Guard {

  constructor(
    private store: Store<AuthState>,
    private auth: AuthService,
    private router: Router
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.checkstore().pipe(
      switchMap(() => this.checkLoggedIn()),
      map(loggedIn => {
        console.log('Logged in Legacy?:', loggedIn);
        if (!loggedIn) {
          this.auth.redirectUrl = state.url;
          const route = this.router.createUrlTree(['/login'], {
            queryParamsHandling: 'merge',
            queryParams: next.queryParams
          });
          return route;
        }
        return loggedIn;
      })
    );
  }

  checkLoggedIn(): Observable<boolean> {
    return this.store.pipe(
      select(getLoggedIn),
      take(1)
    );
  }

  checkstore(): Observable<boolean> {
    return this.store.pipe(
      select(getPending),
      filter(pending => !pending),
      take(1)
    );
  }

}
